"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7162],{

/***/ 59351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SubHeader_SubHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(69447);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(24002);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-bundle.min.css
var swiper_bundle_min = __webpack_require__(72821);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 68 modules
var core_class = __webpack_require__(51270);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/autoplay/autoplay.js
var autoplay = __webpack_require__(7649);
;// CONCATENATED MODULE: ./src/components/DesignSystem/SubHeader/SubHeader/SwiperComponent.js






core_class/* default.use */.Z.use([
    autoplay/* default */.Z
]);
var SingleAnnouncement = function(param) {
    var announcements = param.announcements, backgroundColor = param.backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "hellobar_container",
        style: {
            backgroundColor: "".concat(backgroundColor),
            color: "".concat(backgroundColor === "#ffffff" ? "black" : "white")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
            spaceBetween: 0,
            centeredSlides: true,
            effect: "cube",
            modules: [
                autoplay/* default */.Z
            ],
            children: announcements.map(function(announcement, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                    style: {
                        display: "flex",
                        width: "100vw",
                        alignItems: "center"
                    },
                    children: (announcement === null || announcement === void 0 ? void 0 : announcement.url) !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: announcement.url,
                        target: "_blank",
                        rel: "noreferrer",
                        style: {
                            display: "flex",
                            alignItems: "center",
                            listStyle: "none",
                            textDecoration: "none"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    marginRight: "15px",
                                    color: "".concat(backgroundColor === "#ffffff" ? "black" : "white")
                                },
                                children: announcement.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "Right Button",
                                src: backgroundColor === "#ffffff" ? "/assets/icons/arrow-hellobar-icon-black.svg" : "/assets/icons/arrow-hellobar-icon-white.svg",
                                className: "arrow-btns img h2 mr2 pointer",
                                style: {
                                    width: "14px",
                                    height: "14px"
                                }
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            marginRight: "15px"
                        },
                        children: announcement.title
                    })
                }, index);
            })
        })
    });
};
var MultipleAnnouncement = function(param) {
    var announcements = param.announcements, backgroundColor = param.backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "hellobar_container",
        style: {
            backgroundColor: "".concat(backgroundColor),
            color: "".concat(backgroundColor === "#ffffff" ? "black" : "white")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
            spaceBetween: 0,
            centeredSlides: true,
            effect: "cube",
            loop: true,
            speed: 800,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            modules: [
                autoplay/* default */.Z
            ],
            children: announcements.map(function(announcement, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                    style: {
                        display: "flex",
                        width: "100vw",
                        alignItems: "center"
                    },
                    children: (announcement === null || announcement === void 0 ? void 0 : announcement.url) !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: announcement.url,
                        target: "_blank",
                        rel: "noreferrer",
                        style: {
                            display: "flex",
                            alignItems: "center",
                            listStyle: "none",
                            textDecoration: "none"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    marginRight: "15px",
                                    color: "".concat(backgroundColor === "#ffffff" ? "black" : "white")
                                },
                                children: announcement.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "Right Button",
                                src: backgroundColor === "#ffffff" ? "/assets/icons/arrow-hellobar-icon-black.svg" : "/assets/icons/arrow-hellobar-icon-white.svg",
                                className: "arrow-btns img h2 mr2 pointer",
                                style: {
                                    width: "14px",
                                    height: "14px"
                                }
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            marginRight: "15px",
                            display: "flex"
                        },
                        children: announcement.title
                    })
                }, index);
            })
        })
    });
};
function SwiperComponent(param) {
    var announcementsConfig = param.announcementsConfig;
    var _announcements = announcementsConfig.announcements, announcements = _announcements === void 0 ? [] : _announcements, _backgroundColor = announcementsConfig.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "#000" : _backgroundColor;
    if ((announcements === null || announcements === void 0 ? void 0 : announcements.length) === 0) return null;
    return (announcements === null || announcements === void 0 ? void 0 : announcements.length) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleAnnouncement, {
        announcements: announcements,
        backgroundColor: backgroundColor
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MultipleAnnouncement, {
        announcements: announcements,
        backgroundColor: backgroundColor
    });
}

// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/SubHeader/SubHeader/SubHeader.tsx





var getAnnouncementsFromConfig = function(config) {
    if (config === null || config === void 0 ? void 0 : config.widgets) {
        var ref;
        var ref1 = config === null || config === void 0 ? void 0 : config.widgets[0], status = ref1.status, _color_hex = ref1.color_hex, color_hex = _color_hex === void 0 ? null : _color_hex;
        var announcements = config === null || config === void 0 ? void 0 : (ref = config.widgets) === null || ref === void 0 ? void 0 : ref.map(function(widget) {
            return {
                title: widget.title,
                url: widget.url
            };
        });
        return {
            status: status,
            color_hex: color_hex,
            announcements: announcements
        };
    } else {
        return {};
    }
};
var SubHeader = function(props) {
    var ref;
    var bodyComponents = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1, ref2;
        return (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.components) === null || ref2 === void 0 ? void 0 : ref2.Body;
    }) || [];
    var headerConfig = (ref = bodyComponents.find(function(comp) {
        return comp.sub_type === "HelloBar";
    })) === null || ref === void 0 ? void 0 : ref.config;
    var _config = props.config, config = _config === void 0 ? headerConfig : _config;
    var ref1 = getAnnouncementsFromConfig(config), status = ref1.status, color_hex = ref1.color_hex, announcements = ref1.announcements;
    return status !== constants/* HELLO_BAR_HIDDEN_STATUS */.X8 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperComponent, {
        announcementsConfig: {
            backgroundColor: color_hex,
            announcements: announcements
        }
    }) : null;
};
/* harmony default export */ var SubHeader_SubHeader = (SubHeader);


/***/ })

}]);